<button *ngIf="isEditMode" class="btn btn-primary" type="button" (click)="openAddModule(addModule);">Add Module</button>

<ng-template #addModule let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Add Module To Audit</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="addModuleFrom">
        <div class="modal-body">
            <error-message [errors]="errors"></error-message>

            <div class="row form-group">
                <div class="col-lg-6">
                    <div class="form-group">
                        <label class="col-form-label">Modules</label>
                        <select name="title" class="form-control" formControlName="moduleId">
                            <option *ngFor="let module of modules" [value]="module.id">{{ module.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="form-group">
                        <label class="col-form-label">Audit Type</label>
                        <select name="title" class="form-control" formControlName="auditTypeId">
                            <option *ngFor="let auditType of auditTypes" [value]="auditType.id">{{ auditType.name}}</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="row form-group">
                <div class="col-lg-6">
                    <div class="form-group">
                        <label class="col-form-label">Order</label>
                        <input name="order" class="form-control" formControlName="order" />
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <div class="row">
                <div class="col-md-12 text-right">
                    <button type="button" class="btn btn-danger modal-dismiss mr-1" (click)="modal.close('Close');">Cancel</button>
                    <button type="button" class="btn btn-success modal-dismiss" (click)="addModuleToAudit();" [disabled]="submitAttempt">Ok</button>
                </div>
            </div>
        </div>
    </form>
</ng-template>
